import { useMutation } from "@tanstack/react-query";
import { api } from "../utils/apiClient";

type CreateUserRequest = {
  email: string;
  name: string;
  airlineCode: string;
};

const createUser = async (request: CreateUserRequest): Promise<void> => {
  await api.post("api/v1/users", { json: request });
};

export const useCreateUserMutation = () => {
  return useMutation({
    mutationFn: createUser,
  });
};
